import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { getApiURL } from '../../constants';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import { Image, Images, Label, Link, Partners, Title, TitleSymbol, Wrapper } from './ConferencePartners.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferencePartnersTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    console.log('AA', conf?.partners);

    const organizers = conf?.partners.filter((item) => item?.conferencePartnerType.includes(0) && !item?.isPatron);
    const coorganizers = conf?.partners.filter((item) => item?.conferencePartnerType.includes(1) && !item?.isPatron);
    const mainpartner = conf?.partners.filter((item) => item?.conferencePartnerType.includes(2) && !item?.isPatron);
    const partners = conf?.partners.filter((item) => item?.conferencePartnerType.includes(3) && !item?.isPatron);
    const expertpartner = conf?.partners.filter((item) => item?.conferencePartnerType.includes(4) && !item?.isPatron);
    const promopartner = conf?.partners.filter((item) => item?.conferencePartnerType.includes(5) && !item?.isPatron);
    const mediapartner = conf?.partners.filter((item) => item?.conferencePartnerType.includes(6) && !item?.isPatron);
    const generalpartner = conf?.partners.filter((item) => item?.conferencePartnerType.includes(7) && !item?.isPatron);

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.PARTNERS}`}>
            <Title colors={colors}>
                {t('conference.component.partners.title')}
                <TitleSymbol colors={colors} />
            </Title>

            {organizers.length > 0 && (
                <>
                    <Partners>
                        <Label>{organizers.length === 1 ? t('conference.general.organizer') : t('conference.general.organizers')}:</Label>
                        <Images>
                            {organizers.map((item, index) => (
                                <Link href={item.url} target="_blank" key={`porganizers${index}`}>
                                    <Image
                                        src={`${getApiURL()}/media/thumbnail/partner/${item.photo}?size=200`}
                                        alt={item.photo}
                                        title={item.name}
                                    />
                                </Link>
                            ))}
                        </Images>
                    </Partners>
                </>
            )}

            {coorganizers.length > 0 && (
                <>
                    <Partners>
                        <Label>{t('conference.general.coOrganizers')}:</Label>
                        <Images>
                            {coorganizers.map((item, index) => (
                                <Link href={item.url} target="_blank" key={`pcoorganizers${index}`}>
                                    <Image
                                        src={`${getApiURL()}/media/thumbnail/partner/${item.photo}?size=200`}
                                        alt={item.photo}
                                        title={item.name}
                                    />
                                </Link>
                            ))}
                        </Images>
                    </Partners>
                </>
            )}

            {generalpartner.length > 0 && (
                <>
                    <Partners>
                        <Label>{t('conference.general.generalPartner')}:</Label>
                        <Images>
                            {generalpartner.map((item, index) => (
                                <Link href={item.url} target="_blank" key={`pgeneralpartner${index}`}>
                                    <Image
                                        src={`${getApiURL()}/media/thumbnail/partner/${item.photo}?size=200`}
                                        alt={item.photo}
                                        title={item.name}
                                    />
                                </Link>
                            ))}
                        </Images>
                    </Partners>
                </>
            )}

            {mainpartner.length > 0 && (
                <>
                    <Partners>
                        <Label>{t('conference.general.mainPartner')}:</Label>
                        <Images>
                            {mainpartner.map((item, index) => (
                                <Link href={item.url} target="_blank" key={`pmainpartner${index}`}>
                                    <Image
                                        src={`${getApiURL()}/media/thumbnail/partner/${item.photo}?size=200`}
                                        alt={item.photo}
                                        title={item.name}
                                    />
                                </Link>
                            ))}
                        </Images>
                    </Partners>
                </>
            )}

            {partners.length > 0 && (
                <>
                    <Partners>
                        <Label>{partners.length === 1 ? t('conference.general.partner') : t('conference.general.partners')}:</Label>
                        <Images>
                            {partners.map((item, index) => (
                                <Link href={item.url} target="_blank" key={`ppartners${index}`}>
                                    <Image
                                        src={`${getApiURL()}/media/thumbnail/partner/${item.photo}?size=200`}
                                        alt={item.photo}
                                        title={item.name}
                                    />
                                </Link>
                            ))}
                        </Images>
                    </Partners>
                </>
            )}

            {expertpartner.length > 0 && (
                <>
                    <Partners>
                        <Label>{t('conference.general.professionalPartner')}:</Label>
                        <Images>
                            {expertpartner.map((item, index) => (
                                <Link href={item.url} target="_blank" key={`pexpertpartner${index}`}>
                                    <Image
                                        src={`${getApiURL()}/media/thumbnail/partner/${item.photo}?size=200`}
                                        alt={item.photo}
                                        title={item.name}
                                    />
                                </Link>
                            ))}
                        </Images>
                    </Partners>
                </>
            )}

            {promopartner.length > 0 && (
                <>
                    <Partners>
                        <Label>{t('conference.general.promoPartners')}:</Label>
                        <Images>
                            {promopartner.map((item, index) => (
                                <Link href={item.url} target="_blank" key={`ppromopartner${index}`}>
                                    <Image
                                        src={`${getApiURL()}/media/thumbnail/partner/${item.photo}?size=200`}
                                        alt={item.photo}
                                        title={item.name}
                                    />
                                </Link>
                            ))}
                        </Images>
                    </Partners>
                </>
            )}

            {mediapartner.length > 0 && (
                <>
                    <Partners>
                        <Label>{t('conference.general.mediaPartners')}:</Label>
                        <Images>
                            {mediapartner.map((item, index) => (
                                <Link href={item.url} target="_blank" key={`pmediapartner${index}`}>
                                    <Image
                                        src={`${getApiURL()}/media/thumbnail/partner/${item.photo}?size=200`}
                                        alt={item.photo}
                                        title={item.name}
                                    />
                                </Link>
                            ))}
                        </Images>
                    </Partners>
                </>
            )}
        </Wrapper>
    );
};

export default ConferencePartnersTemplate;
